import { Component, DestroyRef, Inject, OnInit, PLATFORM_ID, TransferState, inject, makeStateKey } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, noop, of, tap } from 'rxjs';

import { MainCategory1 } from 'projects/shared/models/category';
import { CategoryService } from 'projects/shared/services/category.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { NotificationSocketService } from 'projects/shop/src/app/+shared/services/notificationSocket.service';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';

const MAIN_CATEGORIES_KEY = makeStateKey<any>('main-categories-nav-links');

@Component({
  selector: 'app-navbar-links',
  templateUrl: './navbar-links.component.html',
  styleUrls: ['./navbar-links.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class NavbarLinksComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  private readonly supportedLangs = ['en', 'ar'];
  private socketInitialized = false;

  mainCategoryList?: MainCategory1[];
  lang = 'en';
  arabic = false;

  constructor(
    private categoryService: CategoryService,
    private storeChangesServ: StoreChangesService,
    private router: Router,
    private notificationSocketService: NotificationSocketService,
    private transferState: TransferState,
    private _languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    // اللغة بتتحسب من الـ URL الحالي، وبتتحدث مع كل navigation
    this.updateLang(this.router.url);

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(e => this.updateLang(e.urlAfterRedirects));

    this.getAllMainCategories();
    this.language();
  }

  private updateLang(url: string): void {
    const segment = url.split('?')[0].split('#')[0].split('/')[1];
    if (this.supportedLangs.includes(segment)) {
      this.lang = segment;
    }
  }

  language(): void {
    this._languageService.arabic.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(res => {
      this.arabic = res;
    });
  }

  getName(item: any): string {
    const key = this.arabic ? 'ar' : 'en';
    return item?.name?.[key] || item?.name?.['en'] || '';
  }

  trackBySlug(_index: number, item: any): string {
    return item.slug;
  }

  navigateToCategory(item: any): void {
    this.mainCategoriesLocal(item.name);
  }

  mainCategoriesLocal(mainCategoryName: {}): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('mainCategoryNameFromNavbar', JSON.stringify(mainCategoryName));
    }
  }

  getAllMainCategories(): void {
    // لو الداتا جاية من السيرفر (TransferState) منعملش request تاني
    const cached = this.transferState.get<any>(MAIN_CATEGORIES_KEY, null);
    const source$ = cached
      ? of(cached)
      : this.categoryService.getUserMainCategories('?sort=order').pipe(
        tap(response => {
          if (!isPlatformBrowser(this.platformId)) {
            this.transferState.set(MAIN_CATEGORIES_KEY, response);
          }
        })
      );

    source$.pipe(
      tap((response: any) => {
        this.categoryService.mainCategories.next(response);
        this.mainCategoryList = response.data;
        this.initNotificationSocket();
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(noop);
  }

  initNotificationSocket(): void {
    // بنشغله مرة واحدة بس وفي البراوزر بس
    if (this.socketInitialized || !isPlatformBrowser(this.platformId)) return;
    this.socketInitialized = true;

    this.storeChangesServ.getUser().pipe(
      tap(user => {
        if (user) this.notificationSocketService.initSocket(user._id);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(noop);
  }
}